import React from "react";

import { LINK, SMS_LIMIT, count, sampleText, smsLength } from "../../campaignUtils";
import { Field, HelpTip } from "../../shared/StudioControls";

const SUBJECT_LIMIT = { push: 60, email: 160 };

export const ContentEditor = ({ variant, channel, isEditable, onEdit }) => {
  const smsCount = smsLength(variant.body);
  const smsInvalid = channel === "sms" && smsCount > SMS_LIMIT;
  const bodyCount = count(sampleText(variant.body));

  return (
    <div className="cs-editor__form">
      {channel !== "sms" && (
        <Field
          label={channel === "push" ? "Push title" : "Email subject"}
          hint={`${count(sampleText(variant.subject))} of ${SUBJECT_LIMIT[channel]} characters with a sample name`}
        >
          <input disabled={!isEditable} value={variant.subject || ""} onChange={event => onEdit("subject", event.target.value)} />
        </Field>
      )}
      <div className="cs-field">
        <label htmlFor="cs-message-body">Message body</label>
        <textarea
          id="cs-message-body"
          className={smsInvalid ? "is-invalid" : ""}
          aria-invalid={smsInvalid}
          aria-describedby="cs-message-count"
          rows={8}
          disabled={!isEditable}
          value={variant.body}
          onChange={event => onEdit("body", event.target.value)}
        />
        <p id="cs-message-count" className={`cs-counter ${smsInvalid ? "is-invalid" : ""}`} aria-live="polite">
          {smsInvalid && <span aria-hidden="true">! </span>}
          {bodyCount}{channel !== "email" ? ` / ${SMS_LIMIT}` : ""} characters with a sample name
          {smsInvalid && `. ${smsCount - SMS_LIMIT} over the SMS limit. Shorten the message to send it.`}
        </p>
      </div>
      <ul className="cs-hints">
        <li>
          Keep <code>{"{{lead_name}}"}</code> and <code>{"{{deep_link}}"}</code>
          <HelpTip label="About placeholders" points="The backend fills them in for each customer" />
        </li>
        <li>App link: <a href={LINK} target="_blank" rel="noopener noreferrer">{LINK}</a></li>
        <li>
          Counts use a sample name
          <HelpTip
            label="About character counts"
            points={["Long names and Sinhala SMS can use more provider segments", "The backend checks every final message"]}
          />
        </li>
      </ul>
    </div>
  );
};
